import {ONG} from '../../domain/constants.solidarity';
import DEFAULT from './ongs.data.default';
import MSF from './ongs.data.msf';

const raw = {};
raw[ONG.CODE.DEFAULT] = DEFAULT;
raw[ONG.CODE.MSF] = MSF;

export default raw;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/static/ongs.data.static.js